module.exports = __webpack_public_path__ + "img/10.db45ff29.jpg";